import { ATUALIZACOES_BOOK_NAME } from '../constants';

const STORAGE_KEY = 'painelos.aprender.navIntent';
const CHAPTER_VERSAO_ATUAL = 'Versão atual';

export function setAprenderVersionNavIntent(version) {
  const pageVersion = String(version ?? '').trim();
  if (!pageVersion) return;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      bookName: ATUALIZACOES_BOOK_NAME,
      chapterName: CHAPTER_VERSAO_ATUAL,
      pageVersion,
    }),
  );
}

export function peekAprenderNavIntent() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAprenderNavIntent() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function findVersionPageInBookContents(items, version, chapterName = CHAPTER_VERSAO_ATUAL) {
  if (!Array.isArray(items) || !version) return null;
  const needle = String(version).trim();
  for (const item of items) {
    if (item.type !== 'chapter' || item.name !== chapterName || !Array.isArray(item.pages)) continue;
    const page = item.pages.find((p) => String(p.name || '').includes(needle));
    if (page) return { chapterId: item.id, pageId: page.id, page };
  }
  return null;
}
